import moment from 'moment-timezone';
import { urls } from './../../config';
import authFetch from './../../utils/authFetch';

export const NOTIFICATION_REQUEST = 'NOTIFICATION_REQUEST';
export const NOTIFICATION_RECEIVE = 'NOTIFICATION_RECEIVE';
export const NOTIFICATION_SET_MESSAGE_READ = 'NOTIFICATION_SET_MESSAGE_READ';
export const NOTIFICATION_SET_FINANCE_READ = 'NOTIFICATION_SET_FINANCE_READ';
export const NOTIFICATION_SET_UPDATE_READ = 'NOTIFICATION_SET_UPDATE_READ';

const notificationRequest = () => ({
    type: NOTIFICATION_REQUEST
});

const notificationReceive = data => ({
    type: NOTIFICATION_RECEIVE,
    data
});

const notificationFetch = () => {
    return dispatch => {
        dispatch(notificationRequest());
        return authFetch(urls.notification).then(json => {
            const data = {
                unreadMessageItems: (json.messages_list || []).reduce((result, item) => {
                    result[item._id] = item;
                    return result;
                }, {}),
                unreadFinanceItems: (json.finances_list || []).reduce((result, item) => {
                    result[item._id] = item;
                    return result;
                }, {}),
                unreadUpdateItems: (json.updates_list || []).reduce((result, item) => {
                    result[item._id] = item;
                    return result;
                }, {})
            };
            dispatch(notificationReceive(data));
        });
    };
};

const notificationShouldFetch = state => {
    const notification = state.notification;
    if (notification.isFetching) {
        return false;
    }
    if (notification.updatedAt && moment().diff(notification.updatedAt, 'seconds') > 30) {
        return true;
    }
    return notification.didInvalidate;

};

export const notificationFetchIfNeeded = () => {
    return (dispatch, getState) => {
        if (!notificationShouldFetch(getState())) {
            return Promise.resolve();
        }
        return dispatch(notificationFetch());
    };
};

export const notificationSetMessageRead = messageId => ({
    type: NOTIFICATION_SET_MESSAGE_READ,
    messageId
});

export const notificationSetFinanceRead = messageId => ({
    type: NOTIFICATION_SET_FINANCE_READ,
    messageId
});

export const notificationSetUpdateRead = messageId => ({
    type: NOTIFICATION_SET_UPDATE_READ,
    messageId
});



// WEBPACK FOOTER //
// ./src/store/notification/actions.js